module.exports = __webpack_public_path__ + "fonts/TribalIcons.65856b8.woff";